// action
import {
    GET_EMPLOYEE_MASTER,
    GET_EMPLOYEE_MASTER_FAIL,
    GET_EMPLOYEE_MASTER_SUCCESS,
    GET_EMPLOYEE_MASTER_RESET
} from '../action/getEmployeeMasterAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    list: [],
    pagination: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_EMPLOYEE_MASTER:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_EMPLOYEE_MASTER_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_EMPLOYEE_MASTER_SUCCESS:
            return {
                ...state,
                apiState: "success",
                list: action.response.data.data,
                // pagination: action.response.data.data.pagination,
            }
        case GET_EMPLOYEE_MASTER_RESET:
            return initialState
        default:
            return state
    }
}